import React from 'react';
import SellerTypeBadge, { type SellerAccountTypeWire } from 'components/SellerTypeBadge';

export interface ListingSellerTypeInfoProps {
  accountType?: SellerAccountTypeWire | null;
  className?: string;
}

const DISCLAIMERS: Record<'Corporate' | 'Personal', string> = {
  Corporate: 'Bu ilan kurumsal bir satıcı tarafından yayımlanmıştır.',
  Personal: 'Bu ilan bireysel bir kullanıcı tarafından yayımlanmıştır.',
};

const ListingSellerTypeInfo: React.FC<ListingSellerTypeInfoProps> = ({ accountType, className = '' }) => {
  if (accountType !== 'Corporate' && accountType !== 'Personal') {
    return null;
  }

  const isCorporate = accountType === 'Corporate';

  return (
    <div className={`mt-2 ${className}`.trim()}>
      <SellerTypeBadge
        accountType={accountType}
        detailLabel={isCorporate ? 'Kurumsal Satıcı' : 'Bireysel Satıcı'}
      />
      <p className="small text-muted mb-0 mt-2">{DISCLAIMERS[accountType]}</p>
    </div>
  );
};

export default ListingSellerTypeInfo;
